import Layout from "../../components/Layout/Layout";

function Home() {
  return (
    <Layout>
      <div>
        <h1>Boycott List</h1>
        <div>
          <img
            src="https://brandcentral.hp.com/content/dam/sites/brand-central/elem-logo/images/Logo_1_do.jpeg"
            alt="HP Logo"
            width={100}
          />
        </div>
        <div>HP</div>
        <div>HP</div>
      </div>
    </Layout>
  );
}

export default Home;
